/* eslint-disable @typescript-eslint/ban-ts-comment */
import Input from "../../Shared/Input";
import ImgPlaceholder from "../../../assets/ImgPlaceholder.svg";
import PencilIcon from "../../Icons/PencilIcon";
import Button from "../../Shared/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ButtonTypes } from "../../../utils/consts";
import AddIcon from "../../Icons/AddIcon";
import UploadProfile from "../../Shared/UploadProfile";
import { queryClient } from "../../../main";
import { toast } from "react-toastify";
import { CreateSalesAccount } from "../../../api/Sales/CreateSalesAccount";
const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    password: Yup.string()
        .required("Password is required")
        .matches(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Special Character, and One Number"
        ),
    email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    img_url: Yup.string().required("Photo is required"),

});

const AddNewMember = ({ onSuccess }: { onSuccess?: () => void }) => {
    const { mutate, error } = useMutation({
        mutationFn: CreateSalesAccount,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["sales"] });
            toast.success("Sales account created successfully");
            formik.resetForm();
            onSuccess && onSuccess();
        },
        onError: () => {
            formik.setSubmitting(false);
        },
    });

    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            password: "",
            img_url: "",
            email: "",
        },
        validationSchema,
        onSubmit: (values) => {
            //@ts-ignore
            mutate(values);
        },
    });
    const handleimgUrlUpload = (url: string) => {
        formik.setFieldValue('img_url', url);
    };

    return (
        <div className="py-7">
            <h1 className="text-burntBlack font-bold text-[32px] mb-7">Profile</h1>
            <div className="p-8 rounded-xl bg-white border-black/15 shadow flex flex-col justify-end pt-40">
                <form onSubmit={formik.handleSubmit} className="flex gap-12">
                    <div className="relative size-[132px] rounded-full text-center object-cover cursor-pointer">
                        <UploadProfile folder="team_image" onFileUploaded={handleimgUrlUpload}>
                            <div className="absolute z-50 right-0 w-8 h-8 bg-[#2783E9] rounded-full flex items-center justify-center bottom-7">
                                <PencilIcon />
                            </div>
                            {formik.values.img_url && formik.values.img_url !== "" && formik.values.img_url !== "uploading" ? (
                                <img className="rounded-full size-[110px] object-cover" src={formik.values.img_url} />
                            ) : (
                                <img className="rounded-full size-[110px] object-cover" src={ImgPlaceholder} />
                            )}
                        </UploadProfile>
                        {formik.errors.firstName && 
                                                <span className={`text-red-500 text-xs`}>{formik.errors.img_url}</span>
}
                    </div>
                    <div className="w-full space-y-5">
                        <div className="flex gap-7 w-full">
                            <Input
                                value={formik.values.firstName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.firstName && formik.errors.firstName
                                        ? formik.errors.firstName
                                        : ""
                                }
                                className="w-full"
                                title="First Name"
                                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                                name="firstName"
                                placeholder=""
                            />

                            <Input
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.lastName && formik.errors.lastName
                                        ? formik.errors.lastName
                                        : ""
                                }
                                className="w-full"
                                title="Last Name"
                                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                                name="lastName"
                                placeholder=""
                            />
                        </div>

                        <div className="flex gap-7 w-full">
                            <Input
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.email && formik.errors.email
                                        ? formik.errors.email
                                        : ""
                                }
                                className="w-full"
                                title="Email"
                                inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                                name="email"
                                placeholder=""
                            />
                        </div>
                        <Input
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.password && formik.errors.password
                                    ? formik.errors.password
                                    : ""
                            }
                            className="w-full"
                            title="Password"
                            type="password"
                            inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                            name="password"
                            placeholder=""
                        />

                        <Button
                            className="!h-12 w-44 !text-sm font-bold rounded-md ml-auto !bg-[#4379EE] hover:!bg-primary"
                            variant="primary"
                            type={ButtonTypes.SUBMIT}
                        >
                            <AddIcon className="mr-1.5" />
                            Add Sales Account
                        </Button>
                        {error instanceof AxiosError && (
                            <span className="text-red-500 font-bold text-lg">
                                {error?.response?.data?.message || "An error occurred"}
                            </span>
                        )}

                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddNewMember;
